import { GrowthDataSet } from '../../types/data-set.types';

// WHO Length-for-age GIRLS
// Birth to 13 weeks (weekly measurements)
export const whoGirlsLengthWeekly: GrowthDataSet = {
  id: 'who-girls-length-weekly',
  source: 'WHO',
  title: 'Length-for-age',
  intervalType: 'week',
  gender: 'female',
  measurementType: 'height',
  ageRange: { min: 0, max: 13 },
  displayUnit: 'cm',
  dataPoints: [
    {
      age: 0,
      m: 49.1477,
      s: 0.0379,
      sd: 1.8627,
      percentiles: {
        p1: 44.8,
        p3: 45.6,
        p5: 46.1,
        p15: 47.2,
        p25: 47.9,
        p50: 49.1,
        p75: 50.4,
        p85: 51.1,
        p95: 52.2,
        p97: 52.7,
        p99: 53.5,
      },
    },
    {
      age: 1, // Week 1
      m: 50.3298,
      s: 0.03742,
      sd: 1.8833,
      percentiles: {
        p1: 45.9,
        p3: 46.8,
        p5: 47.2,
        p15: 48.4,
        p25: 49.1,
        p50: 50.3,
        p75: 51.6,
        p85: 52.3,
        p95: 53.4,
        p97: 53.9,
        p99: 54.7,
      },
    },
    {
      age: 2, // Week 2
      m: 51.512,
      s: 0.03694,
      sd: 1.9029,
      percentiles: {
        p1: 47.1,
        p3: 47.9,
        p5: 48.4,
        p15: 49.5,
        p25: 50.2,
        p50: 51.5,
        p75: 52.8,
        p85: 53.5,
        p95: 54.6,
        p97: 55.1,
        p99: 55.9,
      },
    },
    {
      age: 3, // Week 3
      m: 52.4695,
      s: 0.03669,
      sd: 1.9251,
      percentiles: {
        p1: 48.0,
        p3: 48.8,
        p5: 49.3,
        p15: 50.5,
        p25: 51.2,
        p50: 52.5,
        p75: 53.8,
        p85: 54.5,
        p95: 55.6,
        p97: 56.1,
        p99: 56.9,
      },
    },
    {
      age: 4, // Week 4
      m: 53.3809,
      s: 0.03647,
      sd: 1.9468,
      percentiles: {
        p1: 48.9,
        p3: 49.7,
        p5: 50.2,
        p15: 51.4,
        p25: 52.1,
        p50: 53.4,
        p75: 54.7,
        p85: 55.4,
        p95: 56.6,
        p97: 57.0,
        p99: 57.9,
      },
    },
    {
      age: 5, // Week 5
      m: 54.2454,
      s: 0.03627,
      sd: 1.9675,
      percentiles: {
        p1: 49.7,
        p3: 50.5,
        p5: 51.0,
        p15: 52.2,
        p25: 52.9,
        p50: 54.2,
        p75: 55.6,
        p85: 56.3,
        p95: 57.5,
        p97: 57.9,
        p99: 58.8,
      },
    },
    {
      age: 6, // Week 6
      m: 55.0642,
      s: 0.03609,
      sd: 1.9873,
      percentiles: {
        p1: 50.4,
        p3: 51.3,
        p5: 51.8,
        p15: 53.0,
        p25: 53.7,
        p50: 55.1,
        p75: 56.4,
        p85: 57.1,
        p95: 58.3,
        p97: 58.8,
        p99: 59.7,
      },
    },
    {
      age: 7, // Week 7
      m: 55.8406,
      s: 0.03593,
      sd: 2.0064,
      percentiles: {
        p1: 51.2,
        p3: 52.1,
        p5: 52.5,
        p15: 53.8,
        p25: 54.5,
        p50: 55.8,
        p75: 57.2,
        p85: 57.9,
        p95: 59.1,
        p97: 59.6,
        p99: 60.5,
      },
    },
    {
      age: 8, // Week 8
      m: 56.5767,
      s: 0.03578,
      sd: 2.0243,
      percentiles: {
        p1: 51.9,
        p3: 52.8,
        p5: 53.2,
        p15: 54.5,
        p25: 55.2,
        p50: 56.6,
        p75: 57.9,
        p85: 58.7,
        p95: 59.9,
        p97: 60.4,
        p99: 61.3,
      },
    },
    {
      age: 9, // Week 9
      m: 57.2761,
      s: 0.03564,
      sd: 2.0413,
      percentiles: {
        p1: 52.5,
        p3: 53.4,
        p5: 53.9,
        p15: 55.2,
        p25: 55.9,
        p50: 57.3,
        p75: 58.7,
        p85: 59.4,
        p95: 60.6,
        p97: 61.1,
        p99: 62.0,
      },
    },
    {
      age: 10, // Week 10
      m: 57.9436,
      s: 0.03552,
      sd: 2.0582,
      percentiles: {
        p1: 53.2,
        p3: 54.1,
        p5: 54.6,
        p15: 55.8,
        p25: 56.6,
        p50: 57.9,
        p75: 59.3,
        p85: 60.1,
        p95: 61.3,
        p97: 61.8,
        p99: 62.7,
      },
    },
    {
      age: 11, // Week 11
      m: 58.5816,
      s: 0.0354,
      sd: 2.0738,
      percentiles: {
        p1: 53.8,
        p3: 54.7,
        p5: 55.2,
        p15: 56.4,
        p25: 57.2,
        p50: 58.6,
        p75: 60.0,
        p85: 60.7,
        p95: 62.0,
        p97: 62.5,
        p99: 63.4,
      },
    },
    {
      age: 12, // Week 12
      m: 59.1922,
      s: 0.0353,
      sd: 2.0895,
      percentiles: {
        p1: 54.3,
        p3: 55.3,
        p5: 55.8,
        p15: 57.0,
        p25: 57.8,
        p50: 59.2,
        p75: 60.6,
        p85: 61.4,
        p95: 62.6,
        p97: 63.1,
        p99: 64.1,
      },
    },
    {
      age: 13, // Week 13
      m: 59.7773,
      s: 0.0352,
      sd: 2.1042,
      percentiles: {
        p1: 54.9,
        p3: 55.8,
        p5: 56.3,
        p15: 57.6,
        p25: 58.4,
        p50: 59.8,
        p75: 61.2,
        p85: 62.0,
        p95: 63.2,
        p97: 63.7,
        p99: 64.7,
      },
    },
  ],
};
